// extracted by mini-css-extract-plugin
module.exports = {"row":"profile_row__1jrOA","forty":"profile_forty__1OEcO","sixty":"profile_sixty__2CXpx"};